import esquire from "@/types/clients/esquire";
import PutResponse from "@/types/clients/esquire/responses/put-response";
import PostContractNotePayload from "@/types/clients/esquire/payloads/post-contract-note-payload";
import PostContractNoteRequest
  from "@/types/clients/esquire/requests/general/post-contract-note-request";
import GetReservationQrCodeRequest
  from "@/types/clients/esquire/requests/general/get-reservation-qr-code-request";

export const postContractNoteRequest = new PostContractNoteRequest(esquire);
export const getReservationQrCodeRequest = new GetReservationQrCodeRequest(esquire);

class ContractApi {

  public async getReservationQrCode(): Promise<Blob | null> {
    return await getReservationQrCodeRequest.send();
  }
  async postContractNote(contractId: string, noteType: string, noteDescription:null|string = null): Promise<PutResponse> {
    const payload = new PostContractNotePayload(contractId, noteType, noteDescription);
    return await postContractNoteRequest.send(payload);

  }
}

export default new ContractApi();
